// Reads a slides make: "# Title", a subtitle line, then each slide as "## Title"
// with "- " bullet points and an optional "Notes:" line for the speaker.

const HEADING = /^(#{1,6})\s+(.*?)\s*#*\s*$/;
const BULLET = /^\s*(?:[-*+•]|\d+[.)])\s+(.*)$/;
const NOTES = /^\s*\**notes\**\s*:\**\s*(.*)$/i;

// { title, subtitle, slides: [{ title, bullets: [text], notes }] }
export function parseSlides(text = "") {
  const deck = { title: "", subtitle: "", slides: [] };
  let slide = null;
  for (const raw of text.replace(/\r\n?/g, "\n").split("\n")) {
    const line = raw.trim();
    if (!line || /^([-*_])(\s*\1){2,}$/.test(line)) continue;
    const heading = HEADING.exec(line);
    if (heading && heading[1].length === 1 && !deck.title && !slide) {
      deck.title = heading[2];
      continue;
    }
    if (heading) {
      slide = { title: heading[2], bullets: [], notes: "" };
      deck.slides.push(slide);
      continue;
    }
    const notes = NOTES.exec(line);
    if (notes && slide) {
      slide.notes = [slide.notes, notes[1]].filter(Boolean).join(" ");
      continue;
    }
    const bullet = BULLET.exec(line);
    if (!slide) {
      // Text before the first slide is the subtitle
      deck.subtitle = [deck.subtitle, bullet ? bullet[1] : line]
        .filter(Boolean)
        .join(" ");
      continue;
    }
    if (bullet) {
      slide.bullets.push(bullet[1]);
    } else if (slide.notes) {
      slide.notes += ` ${line}`;
    } else {
      slide.bullets.push(line);
    }
  }
  return deck;
}
